import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/workflowLaunch/importer/workflowLaunchImporterActions';

export default importerReducers(actions);
